
type column = {
    prop: String;
    label: String;
    width: Number;
};
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    Ref,
} from "vue";

const columnList: Array<any> = [
    // {
    //     prop: "ordersn",
    //     label: "单据编号",
    //     width: 89,
    // },
    {
        prop: "create_time",
        label: "开单时间",
        width: 89,
    },
    {
        prop: "nickname",
        label: "接车人",
        width: 89,
    },
    {
        prop: "settlement_time",
        label: "结算时间",
        width: 89,
    },
    {
        prop: "goodsprice",
        label: "报价",
        width: 89,
    },
    {
        prop: "code",
        label: "车牌号码",
        width: 89,
    },
    {
        prop: "model_name",
        label: "品牌车型",
        width: 89,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 89,
    },
    {
        prop: "send_for_repair",
        label: "送修人",
        width: 89,
    },
    {
        prop: "phone",
        label: "手机",
        width: 89,
    },
    {
        prop: "basicset_type",
        label: "服务类型",
        width: 89,
    },
];
const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];
import { createBackVisit, editBackVisit, getBackVisitInfo, getBasicsetTotalList, getOrderCarOrderinfo, orderList } from "@/api/shenghuiHttp";

export default defineComponent({
    name: "ReturnVisit",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["客户回访"]);

        let pageSize = ref(10),
            currentPage = ref(1),
            loading = ref(false),
            total = ref([0, 0, 0]),
            headClass = inject("headClass"),
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ] as any),
            project = ref([]),
            tableData = ref([] as Array<any>),
            navIndex = ref("1"),

            dialogOrderVisible = ref(false),
            dialogTable = ref([] as Array<any>),
            orderDetail = ref({} as any),

            screenParameter: Ref<any> = ref({
                date: null,
                start_time: null,
                end_time: null,
                search: null,
                is_satisfied: null,
                client_review_status: 1,
                suggest_type: null,
                back_type: null
            }),
            selectList = reactive({
                returnVisit: [],
                visitType: []
            }),
            buttonText = ref(["回访登记", "回访跟进", "回访详情"]),
            dialogFormVisible = ref(false),
            form = ref({
                order_id: null,
                car_code: "",
                is_satisfied: null,
                suggest_type: null,
                suggest: '',
                usage: null,
                abnormal: '',
                back_type: null,
                desc: ''
            }),
            formRef = ref(null);

        let getTableData = () => {
            loading.value = true;
            let data: any = {
                ...screenParameter.value,
                page: currentPage.value,
                pagesize: pageSize.value,
            };
            delete data.date;
            Object.keys(data).forEach((key) => {
                if (data[key] == null) {
                    delete data[key];
                }
            });
            orderList(data).then((res: any) => {
                loading.value = false;
                tableData.value = res?.content?.list || [];
                project.value = res.content.basicset;
                total.value[Number(navIndex.value)] = res?.content?.total || 0;
            });
        },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            columnChange = (item: any) => {
                dialogFormVisible.value = true
                if (navIndex.value == "0") {//回访登记待回访
                    form.value = {
                        order_id: item.id,
                        car_code: item.code,
                        is_satisfied: null,
                        suggest_type: null,
                        suggest: '',
                        usage: null,
                        abnormal: '',
                        back_type: null,
                        desc: ''
                    }
                }
                else if (navIndex.value == "1") {//不满意/异常
                    form.value = {
                        order_id: item.id,
                        car_code: item.code,
                        is_satisfied: null,
                        suggest_type: null,
                        suggest: '',
                        usage: null,
                        abnormal: '',
                        back_type: null,
                        desc: ''
                    }
                    getBackVisitInfo({ order_id: item.id }).then((res: any) => {
                        form.value = {
                            order_id: res.content.list.order_id,
                            car_code: res.content.list.car_code,
                            is_satisfied: res.content.list.is_satisfied,
                            suggest_type: res.content.list.suggest_type,
                            suggest: res.content.list.suggest,
                            usage: res.content.list.usage,
                            abnormal: res.content.list.abnormal,
                            back_type: res.content.list.back_type,
                            desc: res.content.list.desc
                        }
                    }
                    );
                }
                else {//已处理
                    form.value = {
                        order_id: item.id,
                        car_code: item.code,
                        is_satisfied: null,
                        suggest_type: null,
                        suggest: '',
                        usage: null,
                        abnormal: '',
                        back_type: null,
                        desc: ''
                    }
                    getBackVisitInfo({ order_id: item.id }).then((res: any) => {
                        form.value = {
                            order_id: res.content.list.order_id,
                            car_code: res.content.list.car_code,
                            is_satisfied: res.content.list.is_satisfied,
                            suggest_type: res.content.list.suggest_type,
                            suggest: res.content.list.suggest,
                            usage: res.content.list.usage,
                            abnormal: res.content.list.abnormal,
                            back_type: res.content.list.back_type,
                            desc: res.content.list.desc
                        }
                    }
                    );
                }
            },
            pageChangeClick = ((item: any) => {
                navIndex.value = String(item.id);
                screenParameter.value.client_review_status = item.id;
            }),
            onSubmit = () => {
                //console.log(form.value);
                //return;
                if (navIndex.value == "0") {//回访登记
                    createBackVisit({ ...form.value }).then((res: any) => {
                        if (res.status == 202) {
                            dialogFormVisible.value = false;
                            getTableData();
                        }

                    });
                }
                else if (navIndex.value == "1") {//不满意/异常
                    editBackVisit({ ...form.value }).then((res: any) => {
                        if (res.status == 202) {
                            dialogFormVisible.value = false;
                            getTableData();
                        }
                    });
                }
                else {//已处理
                    editBackVisit({ ...form.value }).then((res: any) => {
                        if (res.status == 202) {
                            dialogFormVisible.value = false;
                            getTableData();
                        }
                    });
                }
            },
            getSummariesDia = (param: any, type: number): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                } else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                } else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }

                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击单据编号触发
            getOrderCarinfo = (item: any) => {
                if (item.id <= 0) {
                    return;
                }
                getOrderCarOrderinfo({ order_id: item.id }).then((res: any) => {
                    if (res.status == 200) {
                        dialogOrderVisible.value = true;
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ], [
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ], [
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ], [
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ], [
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '工单备注',
                                info.settlement_notes,
                            ]];
                            dialogTable.value = arr;
                            orderDetail.value = res.content.list;
                        }
                    }
                });
            },
            handleClose = () => {
                dialogOrderVisible.value = false;
            },
            screenChange = (e: string, key: string | null): void => {
                if (key && e) {
                    screenParameter.value.start_time = e[0]
                        ? new Date(e[0]).getTime()
                        : null;
                    screenParameter.value.end_time = e[1]
                        ? new Date(e[1]).getTime()
                        : null;
                }
                getTableData();
            };
        watch(navIndex, (newValue) => {
            screenParameter.value.client_review_status = Number(newValue);
            getTableData();
        });
        onMounted(() => {
            getTableData();
            getBasicsetTotalList({ basicset_type: 6 }).then((res: any) => {
                selectList.returnVisit = res.content.list;
            });
            getBasicsetTotalList({ basicset_type: 7 }).then((res: any) => {
                selectList.visitType = res.content.list;
            });
        });

        return {
            pageSize,
            currentPage,
            columnList,
            loading,
            tableData,
            project,
            handleSizeChange,
            handleCurrentChange,
            total,
            columnChange,
            headClass,
            shortcuts,
            screenChange,
            navIndex,
            screenParameter,
            buttonText,
            dialogFormVisible,
            form,
            formRef,
            onSubmit,
            pageChangeClick,
            selectList,

            dialogOrderVisible,
            getOrderCarinfo,
            handleClose,
            dialogTable,
            orderDetail,
            getSummariesDia,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn
        };
    },
});
